<template>
  <Dialog :visible="visible" class="irinox-dialog-light preorder-dialog" :modal="true" 
              :closable="false" :dismissableMask="true" :style="{width: '500px'}" :draggable="false"
              @update:visible="updateVisible" @show="show">
    
    <template #header>
      <img src="assets/irinox/icons/arrow_back.svg" @click="updateVisible(false)" :alt="$t('common.arrow_left')"/>
      <div>{{ $t('spareParts.cart.manual_add.title') }}</div>
    </template>
    
    <div class="irinox-dialog-light-content layout-content">
      <p class="p-text-center">{{ $t('spareParts.cart.manual_add.subtitle') }}</p>
      <div class="p-grid">
        <div class="p-col-6 p-d-flex p-ai-center p-px-4">
          <InputText v-model="code" :placeholder="$t('spareParts.cart.manual_add.code')" style="width: 100%;"/>
        </div>
        <div class="p-col-6 p-d-flex p-ai-center p-jc-center  p-px-4" style="gap: 10px;">
            <Button icon="pi pi-minus"  @click="() => { if(quantity > 1) quantity-- }"/>
            <div class="big p-text-center" style="width: 30px;">{{ quantity }}</div>
            <Button icon="pi pi-plus" @click="() => { if(quantity < 99) quantity++ }"/>
        </div>
        <div class="p-col-12 p-d-flex p-flex-column p-jc-center p-px-4">
          <label for="notes" class="gray p-text-bold">{{ $t('spareParts.notes') }}</label>
          <Textarea id="notes" v-model="notes" rows="3" :placeholder="$t('spareParts.notes_ph')" />
        </div>
      </div>
    </div>


    <template #footer>
      <Button :label="$t('spareParts.add_button')" @click="buttonClick" :disabled="code==null || code==''" style="width: unset;"/>
    </template>
  </Dialog>

  <IrinoxDialogDark :visible="dialog.error" mode="error" :message="dialog.errorMessage"
    :life="5000" @update:visible="dialog.error = $event" />

  <IrinoxDialogDark :visible="dialog.success" 
    mode="success" 
    :message="$t('spareParts.preorder_success')"
    :life="3000" 
    @update:visible="dialog.success = $event" />

</template>

<script>
import IrinoxDialogDark from '../../IrinoxDialogDark.vue';
import AfterSalesService from '../../../service/AfterSalesService';
import { mapGetters } from 'vuex';

export default {
    components: {
      IrinoxDialogDark,
    },
    emits: ['update:visible'],
    props: {
      visible: Boolean,
    },
    data() {
        return {
          code: null,
          quantity: 1,
          notes: null,
          dialog: {
            error: false,
            errorMessage: null, // $t('spareParts.preorder_error') or $t('spareParts.preorder_error_not_found')
            success: false
          }
        };
    },
    computed: {
      ...mapGetters({
        personaltoken: 'userdata/personaltoken',
      }),
    },
    created() {
      this.afterSalesService = new AfterSalesService();
    },
    methods: {
      updateVisible(value) {
        if(!value) {
          this.code = null;
          this.quantity = 1;
          this.notes = null;
        }
        this.$emit("update:visible", value);
      },
      buttonClick() {

        this.afterSalesService.putSpCart(this.personaltoken, this.code, this.quantity, this.notes)
          .then((data) => {
            if (data.code == "200") {
              this.dialog.success = true;
              this.$store.commit('afterSales/cart', data.body);
            } else {
              console.error(JSON.stringify(data));
              if(data.code == "404") {
                this.dialog.errorMessage = this.$t('spareParts.preorder_error_not_found');
              } else {
                this.dialog.errorMessage = this.$t('spareParts.preorder_error');
              }
              this.dialog.error = true;
            }
          })
          .catch(error => {
            console.error("ERROR " + error);
            this.dialog.errorMessage = this.$t('spareParts.preorder_error');
            this.dialog.error = true;
          })
          .finally(() => {
            this.updateVisible(false);
          });

      },
      show() {
        this.code = null;
        this.quantity = 1;
        this.notes = null;
      },
    }
}
</script>

<style>

</style>